"use client";

import { Suspense } from "react";
import { SessionProvider } from "next-auth/react";
import { PwaClient } from "@/components/pwa/PwaClient";
import { JobAlertModal } from "@/components/pwa/JobAlertModal";
import { EnquiryAlertModal } from "@/components/pwa/EnquiryAlertModal";
import { AppHardNavFallback } from "@/components/app/AppHardNavFallback";

export function Providers({
  children,
  installBrandName = null,
}: {
  children: React.ReactNode;
  installBrandName?: string | null;
}) {
  return (
    <SessionProvider refetchInterval={0} refetchOnWindowFocus={false}>
      <AppHardNavFallback />
      {children}
      <PwaClient installBrandName={installBrandName} />
      <Suspense fallback={null}>
        <JobAlertModal />
        <EnquiryAlertModal />
      </Suspense>
    </SessionProvider>
  );
}
